import { ApiRequestError, type MobileCall } from './api.js';

export interface DealSelectionActions {
  select(dealId: number): Promise<MobileCall>;
  onSelected(call: MobileCall): void;
}

export function renderDealSelectionScreen(
  root: HTMLElement,
  call: MobileCall,
  actions: DealSelectionActions,
): void {
  if (call.dealSelection?.state !== 'required') return;
  root.replaceChildren();
  const card = document.createElement('section');
  card.className = 'card deal-selection-card';
  const eyebrow = document.createElement('p');
  eyebrow.className = 'eyebrow';
  eyebrow.textContent = 'Antes de llamar';
  const title = document.createElement('h1');
  title.textContent = 'Elige la negociación';
  const description = document.createElement('p');
  description.className = 'description';
  description.textContent = 'Selecciona el deal correcto para que el resultado quede registrado donde corresponde.';
  const grid = document.createElement('div');
  grid.className = 'deal-candidate-grid';
  const status = document.createElement('p');
  status.className = 'status';
  status.setAttribute('role', 'status');
  let pending = false;

  const buttons = call.dealSelection.candidates.map((candidate) => {
    const choice = document.createElement('button');
    choice.type = 'button';
    choice.className = 'deal-candidate-button';
    choice.dataset.dealId = String(candidate.dealId);
    choice.textContent = candidate.projectName
      ? `${candidate.title} — ${candidate.projectName}`
      : candidate.title;
    choice.addEventListener('click', async () => {
      if (pending) return;
      pending = true;
      buttons.forEach((button) => { button.disabled = true; });
      status.textContent = 'Confirmando negociación…';
      try {
        actions.onSelected(await actions.select(candidate.dealId));
      } catch (error) {
        const terminal = error instanceof ApiRequestError
          && (error.status === 409 || error.status === 410);
        status.className = terminal ? 'status error' : 'status pending';
        status.textContent = terminal
          ? 'Esta selección ya no es válida. Vuelve a Bitrix y genera la llamada nuevamente.'
          : 'No pudimos confirmar con Bitrix. Intenta nuevamente.';
        if (!terminal) {
          pending = false;
          buttons.forEach((button) => { button.disabled = false; });
        }
      }
    });
    grid.append(choice);
    return choice;
  });

  card.append(eyebrow, title, description, grid, status);
  root.append(card);
}
